import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import avatar from "../../../../assets/media/avatar.png";
import {
  ADD_FAVORITE_CARRIER_URL,
  REMOVE_FAVORITE_CARRIER_URL,
  USER_BLOCK_URL,
  USER_UNBLOCK_URL,
} from "../../../../utils/api-ends";

import store from "../../../../store";
import useHttp from "../../../../hooks/useHttp";
import { isFavoriteValue } from "../../../../store/slices/favorite";
import LoaderImg from "../../../../assets/media/loader.gif";

const SideBar = ({ userProfileData, setUserProfileData }) => {
  const {
    isLoading: isLoadingFavoriteAction,
    error: errorFavoriteAction,
    sendRequests: addOrRemoveFromFavorite
  } = useHttp();
  const {
    isLoading: isLoadingBlockUnblockAction,
    sendRequests: blockOrUnblockUser,
  } = useHttp();
  const favoriteList = useSelector((state) => state.favorite);

  const removeCarrier = (e) => {
    const carrierId = e.target.getAttribute("data-carrierid");
    const response = (data) => {
      store.dispatch(
        isFavoriteValue({
          favoriteValue: false,
        })
      );
    };

    addOrRemoveFromFavorite(
      {
        url: REMOVE_FAVORITE_CARRIER_URL(carrierId),
        method: "DELETE",
      },
      response
    );
  };

  const addCarrier = (e) => {
    const carrierId = e.target.getAttribute("data-carrierid");
    const response = (data) => {
      store.dispatch(
        isFavoriteValue({
          favoriteValue: true,
        })
      );
    };

    addOrRemoveFromFavorite(
      {
        url: ADD_FAVORITE_CARRIER_URL,
        method: "POST",
        data: {
          carrier_id: carrierId,
        },
      },
      response
    );
  };

  // Block user
  const blockUser = () => {
    const response = (data) => {
      setUserProfileData((prevS) => ({
        ...prevS,
        is_blocked: true,
      }));
    };

    blockOrUnblockUser(
      {
        url: USER_BLOCK_URL(userProfileData.id),
        method: "POST",
      },
      response
    );
  };

  // Unblock user
  const unBlockUser = () => {
    const response = (data) => {
      setUserProfileData((prevS) => ({
        ...prevS,
        is_blocked: false,
      }));
    };

    blockOrUnblockUser(
      {
        url: USER_UNBLOCK_URL(userProfileData.id),
        method: "POST",
      },
      response
    );
  };

  return (
    <>
    {errorFavoriteAction && (
      <div className="alert alert-danger">
        {errorFavoriteAction.message}
      </div>
    )}
    
    <div className="col-lg-3 profile-img-area">
      <div className="row mb-3">
        <div className="col-lg-12 col-sm-6">
          <div className="profile-img">
            <img
              src={
                userProfileData?.profile_picture
                  ? userProfileData.profile_picture
                  : avatar
              }
              alt="img"
            />
          </div>
        </div>

        {userProfileData?.own_profile === true ? (
          <div className="col-lg-12 col-sm-6">
            <div className="multiple-btn profile-info-btn">
              <Link
                to="/update-profile/profile-information"
                data={userProfileData?.id}
              >
                <i className="fa-solid fa-user-pen"></i>
                Edit Profile
              </Link>
            </div>
          </div>
        ) : (
          <div className="multiple-btn profile-info-btn">
            {favoriteList.isFavorite === true ? (
              <a
                href="#/"
                onClick={removeCarrier}
                data-carrierid={userProfileData?.carrier_obj?.id}
              >
                Remove Favorite
                {isLoadingFavoriteAction && (
                  <img
                    style={{ width: "25px", "margin-left": "10px" }}
                    src={LoaderImg}
                    alt=""
                  />
                )}
              </a>
            ) : (
              <a
                href="#/"
                onClick={addCarrier}
                data-carrierid={userProfileData?.carrier_obj?.id}
              >
                Add Favorite
                {isLoadingFavoriteAction && (
                  <img
                    style={{ width: "25px", "margin-left": "10px" }}
                    src={LoaderImg}
                    alt=""
                  />
                )}
              </a>
            )}

            {userProfileData?.is_blocked ? (
              <a href="#/" onClick={unBlockUser}>
                Unblock
                {isLoadingBlockUnblockAction && (
                  <img
                    style={{ width: "25px", marginLeft: "10px" }}
                    src={LoaderImg}
                    alt=""
                  />
                )}
              </a>
            ) : (
              <a href="#/" onClick={blockUser}>
                Block
                {isLoadingBlockUnblockAction && (
                  <img
                    style={{ width: "25px", marginLeft: "10px" }}
                    src={LoaderImg}
                    alt=""
                  />
                )}
              </a>
            )}
          </div>
        )}
      </div>
    </div>
    </>
  );
};

export default React.memo(SideBar);
